// extracted by mini-css-extract-plugin
export default {"fieldset":"TestForm_fieldset__Z9yPV","submit":"TestForm_submit__0NTli"};